import styles from '@styles/pages/empresas.module.css'
import { FranchiseCard } from '@components/pages/franchise/franchise-card'
import { Search, SearchData } from '@components/pages/franchise/search'
import { useFranchise } from 'context/franchise'
import router from 'next/router'

export const FurnisherSidebar = () => {
  const { loading, handleClickBack, franchiseSelectedByMap, isMap } =
    useFranchise()

  const changeRoute = (label: string) => {
    router.push(`${label}?map=${isMap ? 'on' : 'off'}`)
  }

  const update = (search?: SearchData) => {
    const { location } = search

    let label = '/fornecedores/empresas-de-energia-solar/'

    if (search?.company) {
      label += search.company.pathLocation
      changeRoute(label)
      return
    }

    if (!location) {
      changeRoute(label)
      return
    }

    if (location?.state) {
      label += location.state.slug + '/' + location.slug
      changeRoute(label)
      return
    }

    label += location.slug
    changeRoute(label)
  }

  return (
    <div className={styles.sidebar}>
      {franchiseSelectedByMap ? (
        <FranchiseCard
          franchise={franchiseSelectedByMap}
          action={{
            onClick: handleClickBack,
            title: 'Voltar'
          }}
          className="border p-3 mb-4"
        />
      ) : (
        <Search loading={loading} onSearch={search => update(search)} />
      )}
    </div>
  )
}
